<template>
  <main class="page-stores page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增门店</el-button>
        <el-button @click="$_batchStores" class="btn__add">批量导入门店</el-button>
      </div>

      <el-form :inline="true" class="filter-form">
        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px;"
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >查无该运营商，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="运营商key:">
          <el-input v-model="filter.platformKey" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px;"
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >查无该品牌，请重新输入</div>
          </div>
        </el-form-item>

         <el-form-item label="系统品牌ID:">
          <el-input v-model.number="filter.brandId" style="width: 110px;" maxlength="9"></el-input>
        </el-form-item>

        <el-form-item label="门店名称:">
          <el-input v-model="filter.storeName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="门店ID:">
          <el-input v-model="filter.storeId" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="共享门店ID:">
          <el-input v-model.number="filter.sscStoreId" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="中台门店ID:">
          <el-input v-model.number="filter.shopId" style="width: 110px;"  maxlength="9"></el-input>
        </el-form-item>

        <el-form-item label="省份:">
          <el-select style="width:110px;" v-model="filter.provinces" filterable placeholder="请选择">
            <el-option value="">省</el-option>
            <el-option
              v-for="item in provinces"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="城市:">
          <el-select style="width:110px;" v-model="filter.citys" filterable placeholder="请选择">
            <el-option value="">市</el-option>
            <el-option
              v-for="item in citys"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="行政区域:">
          <el-select style="width:110px;" v-model="filter.districts" filterable placeholder="请选择">
            <el-option value="">区域</el-option>
            <el-option
              v-for="item in districts"
              :key="item.id"
              :label="item.regionName"
              :value="item.regionCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数据来源:">
          <el-input v-model="filter.dataSources" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
          <el-button @click="$_export" class="export_btn">导出</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="280" :resizable="false">
          <template slot-scope="scope">
            <cd-switch
              v-model="scope.row.status"
              style="margin-right: 10px;"
              @input="$_switch(scope.$index, scope.row)"
              :true-value="1"
              :false-value="2"
            >
              <span slot="open">启用</span>
              <span slot="close">停用</span>
            </cd-switch>
            <el-button class="edit__btn" @click="$_modify(-2, scope.row)" v-if="scope.row.isOperation == false">查看</el-button>
            <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)" v-if="scope.row.isOperation == true">编辑</el-button>
            <el-button class="delete__btn" @click="$_delete(scope.row)" v-if="scope.row.isOperation == true">删除</el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getStoreList"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <batch-stores
      v-if="modal.show && modal.template === 'batch'"
      :title="modal.title"
      @callback="$_callback"
      @close="$_close"
    ></batch-stores>

    <export-stores
      v-if="modal.show && modal.template === 'export-stores'"
      :title="modal.title"
      :filter="lastFilter"
      @callback="$_callback"
      @close="$_close"
    ></export-stores>
  </main>
</template>

<script>
import resize from "@/mixins/resize";
import modalModify from "./modal-modify";
import BatchStores from "./modal-batch-stores";
import ExportStores from "./modal-export-stores";

const columns = [
  { key: "dataSources", label: "数据来源", width: 120 },
  { key: "platformName", label: "运营商", width: 120 },
  { key: "platformKey", label: "运营商key", width: 160 },
  { key: "brandName", label: "品牌", width: 120 },
  { key: "sysBrandId", label: "系统品牌ID", width: 160 },
  { key: "storeName", label: "门店", width: 120 },
  { key: "storeId", label: "门店ID", width: 160 },
  { key: "sscStoreId", label: "共享门店ID", width: 160 },
  { key: "shopId", label: "中台门店ID", width: 160 },
  { key: "provinceName", label: "省份", width: 160 },
  { key: "cityName", label: "城市", width: 160 },
  { key: "areaName", label: "行政区域", width: 160 },
  { key: "imSystemName", label: "门店IM系统", width: 160 },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 },
  { key: "note", label: "备注" }
];
export default {
  name: "merchants-stores",
  mixins: [resize],
  provide() {
    return {
      stores: this,
    }
  },
  data() {
    return {
      lastFilter:{},
      isLoading: false,
      getAllImSystemConfList: [], // 门店IM系统列表
      filter: {
        platformName: "",
        platformKey: "",
        brandId: "",
        brandName: "",
        storeName: "",
        storeId: "",
        shopId: "",
        sscStoreId: "",
        provinces: "", // 全部省份
        citys: "", // 全部城市
        districts: "", // 全部行政区域
        dataSources: "",
      },
      provinces: [],//省份列表
      citys: [],//城市列表
      districts: [],//地区列表
      searchPlatformData: [],
      searchBrandData: [],
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        type: "add",
        template: "",
        data: {}
      }
    };
  },
  watch: {
    'filter.provinces'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'city',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.citys = result.data.concat([]);
          }
        });
      }else{
        this.citys = [];
      }
      //重置
      this.filter.citys = '';
      this.filter.districts  = '';
    },
    'filter.citys'(val) {
      if(val != ''){
        this.$service.post("getRegionData", {
          level: 'area',
          parentRegionCodeId: -1,
          parentRegionCode: val
        }).then(result => {
          if (result.$.checkResult(result, true)) {
            this.districts = result.data.concat([]);
          }
        });
      }else{
        this.districts = [];
      }
      //重置
      this.filter.districts  = '';
    },
    platformName(val) {
      !val && (this.filter.platformKey = "");
    },
    brandName(val) {
      !val && (this.filter.brandId = "");
    },
    storeName(val) {
      !val && (this.filter.currentStoreId = "");
    },
  },
  computed: {
    platformName() {
      return this.filter.platformName;
    },
    brandName() {
      return this.filter.brandName;
    },
    storeName() {
      return this.filter.storeName;
    },
  },
  methods: {
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      let postData = {
        platformName: platformName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getPlatformList", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchPlatformData = result.data.rows.concat([]);

          cb(result.data.rows);
        }
      });
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
      this.filter.platformKey = item.platformKey;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
    },

    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999,
      };
      if (this.filter.platformKey !== "") {
        Object.assign(postData, { platformKey: this.filter.platformKey });
      }
      this.$service.post("getBrands", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if(this.filter.shopId && new RegExp(reg).test(this.filter.shopId)){
         $MessageBox.alert({
         content: `
            <div>中台门店id需填数字！</div>
          `,
        });
      }else if(this.filter.brandId && new RegExp(reg).test(this.filter.brandId)){
         $MessageBox.alert({
          content: `
            <div>系统品牌id需填数字！</div>
          `,
        });
      }else{
        this.$_getStoreList();
      }
    },
    // 重置
    $_reset() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
      this.filter.brandId = "";
      this.filter.brandName = "";
      this.filter.storeName = "";
      this.filter.storeId = "";
      this.filter.shopId = "";
      this.filter.sscStoreId = null;
      this.filter.provinces = "";
      this.filter.citys = "";
      this.filter.districts = "";
      this.filter.dataSources = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getStoreList();
    },
    // 查询品牌列表
    $_getStoreList() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        platformName: this.filter.platformName,
        platformKey: this.filter.platformKey,
        brandName: this.filter.brandName,
        brandId: this.filter.brandId || 0,
        storeName: this.filter.storeName,
        storeId: this.filter.storeId,
        shopId: this.filter.shopId || 0,
        sscStoreId: this.filter.sscStoreId || null,
        provinceCode: this.filter.provinces,
        cityCode: this.filter.citys,
        areaCode: this.filter.districts,
        dataSources: this.filter.dataSources,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.lastFilter = JSON.parse(JSON.stringify(postData));
      this.$service.post("pagingShop", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getStoreList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getStoreList();
    },
    // 新增/编辑门店成功回调
    $_callback() {
      this.$_close();
      this.$_getStoreList();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 新增/编辑/查看
    $_modify($index, row) {
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增门店";
      if ($index !== -1 && $index !== -2) {
        this.modal.type = "edit";
        this.modal.data = JSON.parse(JSON.stringify(row));
        this.modal.title = "编辑门店";
      }
      if ($index === -2) {
        this.modal.type = "read";
        this.modal.data = JSON.parse(JSON.stringify(row));
        this.modal.title = "查看门店";
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },

    // 启用/停用
    $_switch($index, row) {
      const self = this;
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self.$_getStoreList();
          },
        });
      };
      let shopIdList = [row.shopId];
      if (row.status === 1) {
        // 停用切换成启用
        self.$service
          .post("updateStoreStatus", {
            shopIdList,
            status: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              callback(result.msg);
            } else {
              self.dataList[$index].status = 2;
            }
          });
      } else if (row.status === 2) {
        // 启用切换成停用
        $MessageBox.confirm({
          content: `
            <div>是否停用当前门店?</div>
            <div>停用后将会影响门店下面所有接口正常使用,请谨慎!</div>
          `,
          onOk() {
            self.$service
              .post("updateStoreStatus", {
                shopIdList,
                status: 2,
              })
              .then((result) => {
                if (result.$.checkResult(result, true)) {
                  callback(result.msg);
                } else {
                  self.dataList[$index].status = 1;
                }
              });
          },
          onCancel() {
            self.dataList[$index].status = 1;
          },
        });
      }
    },

    // 删除门店
    $_delete(row) {
      const self = this;
      let shopIdList = [row.shopId];
      const content = "是否确认删除门店，结果会删除所有系统的同一个门店"
      $MessageBox.confirm({
        content,
        countDown: 5,//倒计时5秒
        onOk() {
          self.$service
            .post("updateStoreStatus", {
              shopIdList,
              status: 3
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getStoreList();
                  }
                });
              }
            });
        }
      });
    },
    // 批量导入门店
    $_batchStores() {
      this.modal.title = "批量导入门店";
      this.modal.template = "batch";
      this.modal.show = true;
    },
    //导出门店
    $_export(){
      if (!this.lastFilter.platformKey) {
        $MessageBox.alert({ content: "请选择运营商并过滤！" });
        return false;
      }
      this.modal.template = "export-stores";
      this.modal.title = "提示";
      this.modal.show = true;
    },
    getAllImSystemConfData() {
      this.$service.post('getAllImSystemConf').then(result => {
        if (result.$.checkResult(result, true)) {
          this.getAllImSystemConfList = result.data
        }
      })
    }
  },

  mounted() {
    this.isLoading = true;
    this.getAllImSystemConfData()
    this.$service.post("getRegionData", {
      level: 'province',
      parentRegionCodeId: -1
    }).then(result => {
      if (result.$.checkResult(result, true)) {
        this.provinces = result.data.concat([]);
      }
      this.isLoading = false;
    });

    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getStoreList();
  },
  components: {
    modalModify,
    BatchStores,
    ExportStores
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;

      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
  // margin-bottom: 44px;
}
.export_btn{
    width: 64px;
    height: 24px;
    font-size: 13px;
    background-color: #3A405A;
}
</style>

